export default __webpack_public_path__ + "static/media/audit-icon.0757a363.svg";